import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=6cc474c2"
import script from "./Material.vue?vue&type=script&lang=ts"
export * from "./Material.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports